module.exports = __webpack_public_path__ + "fonts/cbe2a65a02cecbef75279b903dd585b3.svg";